module.exports = __webpack_public_path__ + "static/media/jhon_and_george.b75ac9f4.webp";